<script lang="ts">
    import type { DRAWER_POSITION } from "@/constants/drawer";
    import { DRAWER_BUTTON_ELEMENT_NAME } from "@/constants/drawer";
    import RewardsDynamicCustomerIcon from "@apps/rewards/components/RewardsDynamicCustomerIcon.svelte";
    import RewardsPopUpAndDrawerWidgetTheme from "@apps/rewards/components/Theme/RewardsPopUpAndDrawerWidgetTheme.svelte";
    import { REWARDS_BRANDING_ICONS } from "@apps/rewards/constants/constants";
    import type { RewardsStorefrontValuesBrandingEntity } from "@apps/rewards/modules/StorefrontValues/models/RewardsStorefrontValuesEntities";
    import type { Observable } from "rxjs";

    import DrawerButton from "@components/Drawer/DrawerButton.svelte";

    //Props
    export let branding$: Observable<RewardsStorefrontValuesBrandingEntity>;
    export let drawerLabel$: Observable<string>;
    export let direction: DRAWER_POSITION;
</script>

{#if $branding$}
    <RewardsPopUpAndDrawerWidgetTheme branding={$branding$}>
        <div class="gw-rd-drawer-button-wrapper">
            <DrawerButton
                elementName={DRAWER_BUTTON_ELEMENT_NAME.rewards}
                title={$drawerLabel$}
                ariaLabel="Open {$drawerLabel$} sidebar"
                {direction}
                on:click
                on:mouseenter
            >
                <div class="gw-rd-drawer-button-icon" slot="icon">
                    <RewardsDynamicCustomerIcon
                        iconSize="small"
                        viewBox="0 0 24 24"
                        customerIcon={$branding$.popUpWidget.launcher.icon
                            .customUrl}
                        defaultIcon={REWARDS_BRANDING_ICONS[
                            $branding$.popUpWidget.launcher.icon.type
                        ]}
                    />
                </div>
            </DrawerButton>
        </div>
    </RewardsPopUpAndDrawerWidgetTheme>
{/if}

<style lang="postcss">
    .gw-rd-drawer-button-wrapper {
        --gw-drawer-btn-icon-bg-color: var(
            --gw-rd-popup-widget-launcher__theme-color
        );

        .gw-rd-drawer-button-icon {
            width: 16px;
            height: 16px;
            color: var(--gw-rd-popup-widget-launcher__icon-color);
        }
    }
</style>
